import { createBookingCancellation } from "../../data/repository/bookingCancellationRepo";

export const createBookingCancellationUseCase = async (bookingCancellation) => {
  return await createBookingCancellation(bookingCancellation);
};
